import React from 'react'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import grey from '@material-ui/core/colors/grey'
import IconButton from 'lib/ui/IconButton'
import styled from 'styled-components'
import Dialog from 'lib/ui/Dialog'
import StreamForm from 'organization/Event/Room/Stream/StreamForm'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'

export default function StreamEditDialog(props: {
  isOpen: boolean
  onClose: () => void
}) {
  const visible = Boolean(props.isOpen)
  return (
    <Dialog open={visible} onClose={props.onClose}>
      <CloseButton
        onClick={props.onClose}
        aria-label="close edit stream dialog"
      >
        <CloseIcon fontSize="small" />
      </CloseButton>
      <DialogTitle>Custom RTMP stream</DialogTitle>
      <DialogContent>
        <ErrorAlert>
          Changing your Custom RTMP Settings after they have been set will only
          change these settings for the next opening of the room. After you
          close the room, RTMP settings will revert to the setting you set the
          first time.
        </ErrorAlert>
        <StreamForm {...props} />
      </DialogContent>
    </Dialog>
  )
}

const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${(props) => props.theme.spacing[2]};
  right: ${(props) => props.theme.spacing[2]};

  svg {
    color: ${grey[500]};
  }
`
